import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

const boot = () =>
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

const nextFrame = () =>
  new Promise((r) => {
    const t = setTimeout(r, 250);
    requestAnimationFrame(() => {
      clearTimeout(t);
      r();
    });
  });

const splashImg = document.querySelector("#root img");
if (splashImg && splashImg.decode) {
  Promise.race([splashImg.decode().catch(() => {}), new Promise((r) => setTimeout(r, 1200))])
    .then(nextFrame)
    .then(boot);
} else {
  boot();
}

window.addEventListener("click", (e) => {
  const link = e.target.closest && e.target.closest('a[href^="tel:"]');
  if (link && typeof window.fbq === "function") window.fbq("track", "Lead");
});
